import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { PlanTaxiRequestQueryFilter } from '../../shared/types';
import { CITRIN_GET_TRIPS_TAXI, GetTripsTaxiRequest, GetTripsTaxiResponse } from '..';

export const useGetTripsTaxiQuery = (request: PlanTaxiRequestQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: PlanTaxiRequestQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetTripsTaxiResponse, GetTripsTaxiRequest>(CITRIN_GET_TRIPS_TAXI, {
        variables: { request: internalRequest },
        fetchPolicy: 'cache-and-network',
        // onCompleted: (data) => console.log('[MGT] Trips', data),
    });

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getAllPlanTaxiRequests,
        data: data?.CITRIN_MGT_getAllPlanTaxiRequests,
    };
};
